import React from 'react';

const B = {
  blue: '#1565C0',
  navy: '#12355B',
  green: '#45C04A',
  greenAccent: '#65D95A',
};

const SIZES = {
  xs: { icon: 22, text: 'text-lg', gap: 'gap-1.5', tech: 'text-[8px]' },
  sm: { icon: 26, text: 'text-xl', gap: 'gap-2', tech: 'text-[9px]' },
  md: { icon: 32, text: 'text-2xl', gap: 'gap-2.5', tech: 'text-[10px]' },
  lg: { icon: 44, text: 'text-4xl', gap: 'gap-3', tech: 'text-[13px]' },
  xl: { icon: 52, text: 'text-5xl', gap: 'gap-3.5', tech: 'text-[15px]' },
  '2xl': { icon: 64, text: 'text-6xl', gap: 'gap-4', tech: 'text-[18px]' },
};

function MultiplexIcon({ size = 32 }) {
  const win = (x, y, w, h, k) => <rect key={k} x={x} y={y} width={w} height={h} fill="white" opacity="0.92" />;
  return (
    <svg viewBox="0 0 200 200" width={size} height={size} fill="none" aria-hidden="true" className="rendplex-icon flex-shrink-0">
      {/* Green swoosh arrow: semi-circle underneath, rising up-right behind buildings */}
      <g className="rendplex-arrow-group">
        <path d="M 26 116 C 20 152, 62 182, 112 178 C 146 172, 152 128, 170 96 L 178 103 L 190 63 L 150 77 L 158 84 C 146 118, 132 150, 102 158 C 66 166, 38 148, 26 116 Z" fill={B.green} />
      </g>
      {/* Tall navy tower (center-back, 3D) */}
      <polygon points="78,28 118,28 132,20 92,20" fill="#2E77D0" />
      <polygon points="118,28 132,20 132,138 118,146" style={{ fill: 'var(--rp-build-1)' }} />
      <rect x="78" y="28" width="40" height="118" style={{ fill: 'var(--rp-build-2)' }} />
      {[38, 55, 72, 89, 106].map((y) => [85, 102].map((x) => win(x, y, 9, 9, `n${x}-${y}`)))}
      {/* Green building (right, 3D) */}
      <polygon points="124,88 152,88 162,82 134,82" fill={B.greenAccent} />
      <polygon points="152,88 162,82 162,140 152,146" fill={B.greenAccent} />
      <rect x="124" y="88" width="28" height="58" fill={B.green} />
      {[95, 109, 123].map((y) => [129, 141].map((x) => win(x, y, 7, 7, `g${x}-${y}`)))}
      {/* Blue building (front-left, 3D) */}
      <polygon points="48,72 84,72 94,66 58,66" fill="#3D82D6" />
      <rect x="48" y="72" width="36" height="74" style={{ fill: 'var(--rp-build-1)' }} />
      {[79, 94, 109, 124].map((y) => [53, 63, 73].map((x) => win(x, y, 6, 7, `b${x}-${y}`)))}
    </svg>
  );
}

export function RendPlexLogo({ size = 'md', showTech = true, animate = false, className = '' }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className={`flex items-center ${s.gap} ${animate ? 'rendplex-hover' : ''} ${className}`} data-testid="rendplex-logo">
      <MultiplexIcon size={s.icon} />
      <div className="flex flex-col">
        <span className={`font-primary font-semibold ${s.text} leading-none tracking-tight`}>
          <span style={{ color: B.blue }}>RendPle</span>
          <span style={{ color: B.green }}>X</span>
        </span>
        {showTech && (
          <span className={`${s.tech} font-primary font-medium text-slate-500 dark:text-slate-400 lowercase mt-0.5`} style={{ letterSpacing: '0.25em' }}>
            technologies
          </span>
        )}
      </div>
    </div>
  );
}

export function RendPlexLogoCompact({ className = '' }) {
  return (
    <span className={`font-primary font-semibold tracking-tight ${className}`} data-testid="rendplex-logo-compact">
      <span style={{ color: B.blue }}>RendPle</span>
      <span style={{ color: B.green }}>X</span>
    </span>
  );
}

export function RendPlexIcon({ size = 32, className = '' }) {
  return (
    <span className={`inline-flex ${className}`} data-testid="rendplex-icon">
      <MultiplexIcon size={size} />
    </span>
  );
}

export default RendPlexLogo;
